import { FinancialDocument } from "../../common/types/financialDocument";
import { FinancialDocumentPreview } from "../documents/FinancialDocumentDetails/FinancialDocumentPreview";
import { ImporterDataPreview } from "./ImporterDataPreview";
import styles from "./ImporterPage.module.scss";

interface Props {
    documentRowId: string;
    financialDocument: FinancialDocument;
}

export const ImporterDocumentPreview: React.FC<Props> = ({
    documentRowId,
    financialDocument,
}) => (
    <section className={styles.preview}>
        <FinancialDocumentPreview
            financialDocument={financialDocument}
            className={styles.filePreview}
        />
        <div className={styles.dataPreview}>
            <ImporterDataPreview
                documentRowId={documentRowId}
                financialDocument={financialDocument}
            />
        </div>
    </section>
);
